import React from 'react';
import PropTypes from 'prop-types';

// Since this component is simple and static, there's no parent container for it.
const AdditionServiceCheckbox = ({ readOnly, label, onChange, isChecked, color, disabled,price }) => {
    return (
        <div className="checkbox">
            <label disabled={disabled} className="checkbox-section custom-checkbox">
                <input disabled={disabled} type="checkbox" readOnly={readOnly} className="custom-control-input" checked={isChecked} onChange={onChange} />
                {
                    isChecked?(<span className="custom-control-indicator" style={color ? {color: color} : null}><i className="cr-icon fa fa-check" /></span>)
                    :(<span className="custom-control-indicator" style={color ? {color: color} : null}><i className="cr-icon fa fa-plus" /></span>)
                }
                
                <span className="custom-control-description" style={color ? {color: color} : null}>{label}</span>
                <span className="custom-control-price" style={color ? {color: color} : null}>{`€ ${price.toFixed(2)}`}</span>
            </label>
        </div>
    );
};

AdditionServiceCheckbox.propTypes = {
    readOnly: PropTypes.bool,
    label: PropTypes.string,
    onChange: PropTypes.func,
    isChecked: PropTypes.bool,
    color: PropTypes.string,
    disabled: PropTypes.bool,
    price:PropTypes.number
};

export default AdditionServiceCheckbox;



// WEBPACK FOOTER //
// ./src/components/AdditionServiceCheckbox.jsx